<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      商品管理
      <small>
        /&nbsp;
        <router-link to="/infomanagement" class="TitleStyle">商品列表</router-link>/&nbsp;商品明细
      </small>
    </h1>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">商品明细</h4>
              </div>
              <div class="panel-body">
              <!-- end panel-heading --> 
               <el-table :data="UserManagementList" border style="width: 100%">
                 
                  <el-table-column prop="brandName" label="商品名称"  header-align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="operator" label="详情编码" align="center"></el-table-column>
                  <el-table-column prop="brandId" label="详情描述"  header-align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="operator" label="详情URL" align="center"></el-table-column>
                  <el-table-column prop="updateTime" label="状态" align="center"></el-table-column>
                  <el-table-column prop="currentstatus" label="操作人" align="center"></el-table-column>
                  <el-table-column prop="currentstatus" label="操作时间" align="center"></el-table-column>
               </el-table>
              
            
            <!-- end panel -->
            
           <div style="height:46px;padding-top:16px;">
                       <a  class="btn btn-primary m-r-5 BackButton" @click="GoBack" >返&nbsp;&nbsp;回</a>
                      
                        <span class="clear"></span>
                  </div>
                  </div>
              </div> 
          </div> 
          <!-- end col-10 -->
        </div>    
  
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>

  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";

export default {
  name: "InventoryDetailList",
  data() {
    return {
      UserManagementList:[]
    };
  },
  mounted: function() {},
  methods: {
    initdata() {},
    GoBack(){
      this.$router.go(-1)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ModelPadding {
  margin-top: -30px;
}
.LineSpacing {
  margin-top: 16px;
}
.ButtonColor {
  color: #fff !important;
}

.OrderInfo {
  padding: 20px 30px;
}
.GTitle {
  border-top: 3px #84caf3 solid;
  overflow: hidden;
  line-height: 25px;
  border-right: 1px #e5e5e5 solid;
  background: #f4f4f4;
}
.TInfo {
  position: relative;
  min-width: 130px;
  float: left;
  font-size: 16px;
  padding: 5px 15px;
  background-color: #84caf3;
  color: #ffffff;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}

.TitleStyle {
  color: #6a7786;
}
@media screen and (min-width:1360px) and (max-width:1680px){ /*二栏布局*/ .TableContent{width: 50%;}  }
@media screen and (min-width:1680px) and (max-width:2000px){ /*二栏布局*/ .TableContent{width: calc(100%/3);}  }
.TableContent {
  float: left;
}
.GContentUl {
  list-style: none;
}
.TCode {
  color: #999999;
  text-align: left;
  display: inline-block;
  width: 105px;
  overflow: hidden;
  font-size: 14px;
  float: left;
  padding-left: 16px;
  padding-top:8px;
  padding-bottom: 8px;
}
.TCodeContent {
  font-size: 12px;
  float: left;
  width: calc(100% - 105px);
  line-height: 20px;
  text-align: left;
  word-break: normal;
  word-wrap: break-word;
  padding-top:8px;
  padding-bottom: 8px;
}
.BackButton{
  float:right;
  cursor:pointer;
  color:#fff !important
}

</style>



// WEBPACK FOOTER //
// src/components/CommoditiesList/InfoDetailed.vue